export const validateFullName = async (rule,value) => {
    if(value && value.length < 2){
        throw new Error('Debe tener al menos 2 caracteres de longitud');
    }

    if(value && !(/^[a-zA-ZÑñáéíóúÁÉÍÓÚ]+$/).test(value)){
        throw new Error('Debe contener solamente caracteres alfabeticos');
    }
}

export const validateEmail = async (rule,value) => {
    if(value && !(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value))){
        throw new Error("Debe insertar un email valido");
    }
}

export const validatePassword = async (rule,value) => {

    if(value && value.length < 6){
        throw new Error('Debe tener al menos 6 caracteres de longitud');
    }

    if(value && !(/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?])\S+$/.test(value))){
        throw new Error('Debe tener al menos una letra, un numero y un caracter especial sin espacios en blanco');
    }

}

export const validatePhone = async (rule,value) => {
    if(value && !(/^[0-9]{1}[0-9]{7}$/.test(value) || /^[0-9]{2}[0-9]{6}$/.test(value) || /^[0-9]{9}$/.test(value))){
        throw new Error('Debe ser un telefono valido');
    }
}